var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotLiked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2.5rem",
    height: "2.5rem",
    viewBox: "0 0 32 32",
    stroke: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.886 5.115a6.376 6.376 0 0 1 6.376 6.376 6.354 6.354 0 0 1-1.964 4.6L16.001 26.44 5.517 15.904a6.35 6.35 0 0 1-1.778-4.413 6.376 6.376 0 0 1 12.262-2.452 6.377 6.377 0 0 1 5.886-3.924zm0-1.066A7.424 7.424 0 0 0 16 6.933a7.42 7.42 0 0 0-5.886-2.884c-4.104 0-7.442 3.339-7.442 7.442 0 1.928.737 3.758 2.075 5.152L16 27.952l11.053-11.108a7.368 7.368 0 0 0 2.275-5.352c0-4.104-3.339-7.442-7.442-7.442z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotLiked);
export default __webpack_public_path__ + "static/media/not-liked.df958b176e718634548639f9da6a5aae.svg";
export { ForwardRef as ReactComponent };